import type { GraphQLPage } from '~/types/graphql';

export const useGetPage = async (slug: string, locale: string) => {
  const { isPreview, previewQuery, previewKeyPart } = usePreview();
  const key = `pageData-${previewKeyPart}${slug}-${locale}`;

  const { data: cached } = useNuxtData<GraphQLPage | null>(key);

  if (cached.value && !isPreview) {
    return { data: cached, error: ref(null) };
  }

  const headers = import.meta.server ? useRequestHeaders(['cookie']) : undefined;

  return useAsyncData<GraphQLPage | null>(
    key,
    async () => {
      const page = await $fetch<GraphQLPage | null>('/api/page', {
        query: { slug, locale, ...previewQuery },
        headers,
      });
      return page ?? null;
    },
    {
      dedupe: 'defer',
    }
  );
};
